import { Pipe, PipeTransform } from '@angular/core';
import { PosStatusBadgeTypes } from '../constants/index';

@Pipe({
  name: 'storeStatus',
  pure: false,
  standalone: true,
})
export class StoreStatusPipe implements PipeTransform {
  transform(value: any, args?: string): string {
    const typeFlag = 'type'; // returns the type for the given store status
    let result = 'DEFAULT';

    if (args && args === typeFlag) {
      result = PosStatusBadgeTypes[value] || 'DEFAULT';
    } else {
      result = `store.grid.${value}`;
    }
    return result;
  }
}
